import { MultiSelect } from "primereact/multiselect";
import { IAssetTypes } from "../models/asset";

interface IGroupMultiSelectProps {
    assets: IAssetTypes[];
    value: string[];
    onChange: (value: string[]) => void;
    onChangeSelectedLabel?: (label: string) => void;
}

const GroupMultiSelect = ({ assets, value, onChange, onChangeSelectedLabel }: IGroupMultiSelectProps) => {
    const getFamilyName = (code: string) => {
        return {
            "F": "Renda fixa",
            "V": "Renda variável",
            "C": "Conta corrente",
            "P": "Imóveis",
            "M": "Veículos",
            "U": "Moedas",
            "T": "Ações/Criptos"
        }[code];
    }
    const groups = Array.from(new Set(assets.map(type => type.asset_family)))
        .map(group => ({ name: getFamilyName(group), code: group }));

    return (
        <MultiSelect 
            value={value}
            filter 
            onChange={(e) => {
                onChange(e.value);
                if (e.value.length === 0) {
                    onChangeSelectedLabel?.("");
                    return;
                }

                if (e.value.length > 2) {
                    onChangeSelectedLabel?.(`${e.value.length} selecionados`);
                    return;
                }

                onChangeSelectedLabel?.((e.value as string[]).map(group => getFamilyName(group)).join(", "));
            }} 
            options={groups} 
            optionLabel="name" 
            optionValue="code"
            placeholder="Selecione os grupos" 
            maxSelectedLabels={2} 
            className="w-full" 
        />
    )
}

export default GroupMultiSelect;
